import { DownOutlined, UserOutlined } from '@ant-design/icons';
import { Button, Drawer } from 'antd';
import LoginModal from 'components/LoginModal/LoginModal';
import { clearAuthorizationBase } from 'config/axiosBase';
import { useCallback, useEffect, useRef, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { getAllSetting } from '../../service/base';
import { CONST_SITE, LocalStorageKey } from '../../utils/common/const';
import CountDownFinal from './CountDownFinal';

const navItems = [
  { name: 'TRANG CHỦ', href: '#' },
  { name: 'DỰ ĐOÁN', href: '/' },
  { name: 'THỂ LỆ', href: '/rule' },
  { name: 'KẾT QUẢ', href: '/prize-structure' },
  { name: 'LỊCH SỬ', href: '/history' }
];

const HISTORY_PATH = '/history';

const Header = () => {
  const location = useLocation();
  const activeNav = location.pathname;
  const [settings, setSettings] = useState({
    link_login: '#',
    link_register: '#',
    link_home: '#'
  });
  const mounted = useRef(false);
  const [isShowMenu, setIsShowMenu] = useState(false);
  const [isLoginModalOpen, setIsLoginModalOpen] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(
    () => !!localStorage.getItem(LocalStorageKey.ACCESS_TOKEN)
  );
  const [authAccount, setAuthAccount] = useState(() => localStorage.getItem('userAccount') || '');
  const [userMenuOpen, setUserMenuOpen] = useState(false);
  const userMenuRefDesktop = useRef(null);
  const userMenuRefMobileBar = useRef(null);
  const userMenuRefDrawer = useRef(null);

  const syncAuthState = useCallback(() => {
    setIsLoggedIn(!!localStorage.getItem(LocalStorageKey.ACCESS_TOKEN));
    setAuthAccount(localStorage.getItem('userAccount') || '');
    window.dispatchEvent(new CustomEvent('sc88-auth-change'));
  }, []);

  const openLoginModal = () => setIsLoginModalOpen(true);

  const handleLogout = () => {
    localStorage.removeItem(LocalStorageKey.ACCESS_TOKEN);
    localStorage.removeItem(LocalStorageKey.REFRESH_TOKEN);
    localStorage.removeItem(LocalStorageKey.USER_INFO);
    clearAuthorizationBase();
    setUserMenuOpen(false);
    syncAuthState();
  };

  useEffect(() => {
    mounted.current = true;

    const fetchData = async () => {
      try {
        const res = await getAllSetting({
          site: CONST_SITE.SC88
        });
        if (mounted.current) {
          const settingsMap = {};
          res.data.forEach((item) => {
            settingsMap[item.key] = item.content || '#';
          });
          setSettings(settingsMap);
          // Update the home link in navItems
          navItems[0].href = settingsMap.link_home || '/';
        }
      } catch (error) {
        console.error('Error fetching settings:', error);
      }
    };

    fetchData();

    return () => {
      mounted.current = false;
    };
  }, []);

  useEffect(() => {
    const onOpenLogin = () => setIsLoginModalOpen(true);
    window.addEventListener('sc88-open-login', onOpenLogin);
    return () => window.removeEventListener('sc88-open-login', onOpenLogin);
  }, []);

  useEffect(() => {
    if (!userMenuOpen) return;
    const onDown = (e) => {
      const inDesktop = userMenuRefDesktop.current?.contains(e.target);
      const inMobileBar = userMenuRefMobileBar.current?.contains(e.target);
      const inDrawer = userMenuRefDrawer.current?.contains(e.target);
      if (!inDesktop && !inMobileBar && !inDrawer) {
        setUserMenuOpen(false);
      }
    };
    document.addEventListener('mousedown', onDown);
    return () => document.removeEventListener('mousedown', onDown);
  }, [userMenuOpen]);

  return (
    <div className="w-full overflow-x-hidden">
      <div
        className="w-full max-w-[1199px] mx-auto mt-2 md:mt-8 rounded-[20px] md:rounded-[100px]
            flex flex-row justify-between items-center 
            bg-[#E8EBEE]
            px-[12px] md:px-[40px] py-[24px]
            h-[80px] md:h-[88px] lg:h-[96px] gap-[8px]"
        style={{
          boxShadow:
            '5px 5px 10px #F27121, -4px -4px 10px #FFFFFF66, inset 5px 5px 5px #FFFFFF, inset -5px -5px 10px #FEB562',
          boxSizing: 'border-box'
        }}
      >
        <div className="flex xl:hidden justify-start items-center">
          <Drawer
            placement="left"
            onClose={() => {
              setIsShowMenu(false);
              setUserMenuOpen(false);
            }}
            open={isShowMenu}
            closeIcon={null}
            width={260}
            bodyStyle={{ padding: 0, position: 'relative' }}
            style={{
              // Hide scrollbar for the Drawer
              overflow: 'auto',
              scrollbarWidth: 'none', // For Firefox
              msOverflowStyle: 'none' // For IE, Edge
            }}
            // For Ant Design Drawer: pass className to customize scrollbar for inner content
            className="drawer-hide-scrollbar"
          >
            {/* Inline scrollbar-hide CSS for injected content */}
            <style>
              {`
                  .drawer-hide-scrollbar {
                    scrollbar-width: none !important;        /* Firefox */
                    -ms-overflow-style: none !important;     /* IE and Edge */
                  }
                  .drawer-hide-scrollbar::-webkit-scrollbar {
                    display: none !important;                /* Chrome, Safari and Opera */
                    width: 0 !important;
                    background: transparent !important;
                  }
                `}
            </style>
            {/* Logo on Top */}
            <div
              className="flex items-center justify-center w-full py-6 border-b border-gray-200"
              style={{ background: '#FFFFFF' }}
            >
              <Link to="/">
                <img
                  src="/assets/images/header/logo.png"
                  alt="Logo"
                  className="h-[40px] w-auto object-contain mx-auto"
                />
              </Link>
            </div>
            {/* Close Button X */}
            <button
              onClick={() => setIsShowMenu(false)}
              className="absolute top-3 right-3 z-10 hover:opacity-80 transition-opacity"
              aria-label="Đóng menu"
              style={{
                background: 'transparent',
                border: 'none',
                cursor: 'pointer',
                padding: 0
              }}
            >
              <img
                src="/assets/images/header/close.png"
                alt="Close"
                className="w-8 h-8 object-contain"
                style={{
                  filter:
                    'brightness(0) saturate(100%) invert(47%) sepia(95%) saturate(1752%) hue-rotate(349deg) brightness(97%) contrast(93%)'
                }}
              />
            </button>
            {/* Hide scrollbar for this menu list as well */}
            <div
              className="flex flex-col h-full"
              style={{ background: '#FFFFFF', overflow: 'auto' }}
            >
              <Link
                to={navItems[0].href || '/'}
                onClick={() => {
                  setIsShowMenu(false);
                }}
                className="flex items-center px-5 py-4 hover:bg-[#f27121] hover:text-white font-bold text-xl text-[#f27121] transition-colors"
              >
                TRANG CHỦ
              </Link>
              <Link
                to="/"
                onClick={() => {
                  setIsShowMenu(false);
                }}
                className="flex items-center px-5 py-4 hover:bg-[#f27121] hover:text-white font-bold text-xl text-[#f27121] transition-colors"
              >
                DỰ ĐOÁN
              </Link>
              <Link
                to="/rule"
                onClick={() => {
                  setIsShowMenu(false);
                }}
                className="flex items-center px-5 py-4 hover:bg-[#f27121] hover:text-white font-bold text-xl text-[#f27121] transition-colors"
              >
                THỂ LỆ
              </Link>
              <Link
                to="/prize-structure"
                onClick={() => {
                  setIsShowMenu(false);
                }}
                className="flex items-center px-5 py-4 hover:bg-[#f27121] hover:text-white font-bold text-xl text-[#f27121] transition-colors"
              >
                KẾT QUẢ
              </Link>
              {isLoggedIn ? (
                <Link
                  to={HISTORY_PATH}
                  onClick={() => {
                    setIsShowMenu(false);
                  }}
                  className="flex items-center px-5 py-4 hover:bg-[#f27121] hover:text-white font-bold text-xl text-[#f27121] transition-colors"
                >
                  LỊCH SỬ
                </Link>
              ) : (
                <button
                  type="button"
                  onClick={() => {
                    setIsShowMenu(false);
                    openLoginModal();
                  }}
                  className="flex items-center px-5 py-4 hover:bg-[#f27121] hover:text-white font-bold text-xl text-[#f27121] transition-colors w-full text-left bg-transparent border-0 shadow-none outline-none appearance-none cursor-pointer focus:outline-none focus-visible:outline-none focus-visible:ring-0"
                >
                  LỊCH SỬ
                </button>
              )}
              {isLoggedIn ? (
                <div ref={userMenuRefDrawer} className="border-t border-gray-100 bg-white">
                  <button
                    type="button"
                    className="flex w-full border-none items-center gap-3 px-5 py-4 text-left transition-colors hover:bg-[#fafbfc]"
                    onClick={() => setUserMenuOpen((o) => !o)}
                    aria-expanded={userMenuOpen}
                  >
                    <div className="flex min-w-0 flex-1 flex-col gap-0.5">
                      <span className="text-[12px] font-normal leading-tight text-[#6b7280]">
                        Xin chào
                      </span>
                      <span className="truncate text-[15px] font-bold leading-tight text-[#111827]">
                        {authAccount || 'Thành viên'}
                      </span>
                    </div>
                    <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-primary shadow-sm">
                      <UserOutlined className="text-[18px] text-white" />
                    </div>
                    <DownOutlined
                      className={`shrink-0 text-[12px] text-[#6b7280] transition-transform duration-200 ${
                        userMenuOpen ? 'rotate-180' : ''
                      }`}
                    />
                  </button>
                  {userMenuOpen ? (
                    <div className="w-full bg-white">
                      <button
                        type="button"
                        className="w-full border-0 bg-white px-5 py-3.5 text-left text-[15px] font-bold text-[#111827] shadow-none outline-none ring-0 transition-colors hover:bg-[#f3f4f6]"
                        onClick={() => {
                          setUserMenuOpen(false);
                          setIsShowMenu(false);
                          handleLogout();
                        }}
                      >
                        Đăng xuất
                      </button>
                    </div>
                  ) : null}
                </div>
              ) : (
                <>
                  <button
                    type="button"
                    className="flex items-center px-5 py-4 font-bold text-xl text-[#f27121] transition-colors w-full text-left bg-transparent border-0 cursor-pointer hover:bg-[#f27121] hover:text-white"
                    onClick={() => {
                      setIsShowMenu(false);
                      openLoginModal();
                    }}
                  >
                    Đăng nhập
                  </button>
                  <Link
                    to={settings.link_register}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center px-5 py-4 hover:bg-[#f27121] hover:text-white font-bold text-xl text-[#f27121] transition-colors"
                    onClick={() => {
                      setIsShowMenu(false);
                    }}
                  >
                    Đăng ký
                  </Link>
                </>
              )}
            </div>
          </Drawer>
          <Button type="link" onClick={() => setIsShowMenu(true)} style={{ color: '#f27121' }}>
            <img
              src="/assets/images/header/menu.png"
              alt=""
              className="h-[32px] w-[32px] md:w-auto object-contain mt-1"
              style={{
                filter:
                  'brightness(0) saturate(100%) invert(47%) sepia(95%) saturate(1752%) hue-rotate(349deg) brightness(97%) contrast(93%)'
              }}
            />
          </Button>
        </div>
        <div className="flex justify-center items-center shrink-0">
          <Link key={navItems[0].name} to={navItems[0].href || '/'}>
            <img
              src="/assets/images/header/logo.png"
              alt=""
              className="h-[32px] md:h-[50px] mt-2 md:mt-0 w-auto object-contain"
            />
          </Link>
        </div>
        <div className="flex justify-center items-center flex-1">
          <div className="xl:flex hidden flex-row justify-center items-center w-full gap-3 xl:gap-6">
            {navItems.map((item) => {
              const navClass = `text-center text-[14px] px-4 py-1.5 rounded-lg lg:text-[15px] xl:text-[16px] font-semibold ${
                activeNav === item.href
                  ? 'text-[#FFF] bg-[#f27121]'
                  : 'text-[#3E4C5C] bg-transparent'
              } ${item.name === 'TRANG CHỦ' ? 'hidden md:block' : ''}`;
              if (item.href === HISTORY_PATH && !isLoggedIn) {
                return (
                  <button
                    key={item.name}
                    type="button"
                    onClick={openLoginModal}
                    className={`${navClass} border-0 shadow-none outline-none appearance-none focus:outline-none focus-visible:outline-none focus-visible:ring-0`}
                  >
                    {item.name}
                  </button>
                );
              }
              return (
                <Link key={item.name} to={item.href} className={navClass}>
                  {item.name}
                </Link>
              );
            })}
          </div>
        </div>
        <div className="flex justify-end shrink-0">
          <div className="flex flex-row justify-end items-center gap-2 sm:gap-3 xl:gap-4 h-full min-w-0">
            {isLoggedIn ? (
              <div className="relative hidden xl:block" ref={userMenuRefDesktop}>
                <button
                  type="button"
                  onClick={() => setUserMenuOpen((v) => !v)}
                  className="flex max-w-[min(100%,280px)] items-center gap-2.5 rounded-[14px] border border-[#e5e7eb] bg-white/95 px-3 py-2 shadow-[0_1px_3px_rgba(15,23,42,0.06)] transition-colors hover:bg-white"
                  aria-expanded={userMenuOpen}
                >
                  <div className="flex min-w-0 flex-1 flex-col items-start gap-0.5 text-left">
                    <span className="text-[12px] font-normal leading-tight text-[#6b7280]">
                      Xin chào
                    </span>
                    <span
                      className="max-w-[140px] truncate text-[14px] font-bold leading-tight text-[#111827]"
                      title={authAccount || undefined}
                    >
                      {authAccount || 'Thành viên'}
                    </span>
                  </div>
                  <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-primary shadow-sm">
                    <UserOutlined className="text-[16px] text-white" />
                  </div>
                  <DownOutlined
                    className={`shrink-0 text-[11px] text-[#6b7280] transition-transform duration-200 ${
                      userMenuOpen ? 'rotate-180' : ''
                    }`}
                  />
                </button>
                {userMenuOpen ? (
                  <div className="absolute right-0 top-[calc(100%+6px)] z-[100] min-w-[180px] overflow-hidden rounded-[12px] bg-white shadow-none ring-0">
                    <button
                      type="button"
                      className="w-full border-0 bg-white px-4 py-3.5 text-left text-[15px] font-bold text-[#111827] shadow-none outline-none ring-0 transition-colors hover:bg-[#f3f4f6]"
                      onClick={() => {
                        setUserMenuOpen(false);
                        handleLogout();
                      }}
                    >
                      Đăng xuất
                    </button>
                  </div>
                ) : null}
              </div>
            ) : (
              <>
                <button
                  type="button"
                  onClick={openLoginModal}
                  className="hidden xl:flex items-center justify-center px-[25px] py-[4px] pt-[8px] h-[46px] w-[134px] rounded-[109px] font-bold text-[16px] leading-[24px] text-center whitespace-nowrap text-[#f27121] border-0 cursor-pointer"
                  style={{
                    background: 'linear-gradient(to bottom, #ffffff, #e9e1e1)',
                    border: '2px solid transparent',
                    boxShadow: '0px 4px 6px -1px #f27121'
                  }}
                >
                  ĐĂNG NHẬP
                </button>
                <div
                  className="hidden xl:flex bg-[#feb562] flex-col items-start p-px rounded-full w-[134px] h-[46px]"
                  style={{
                    boxShadow:
                      '0px 12.522px 10.017px 0px rgba(255, 118, 20, 0.13), 0px 6.65px 5.32px 0px rgba(255, 118, 20, 0.11), 0px 2.767px 2.214px 0px rgba(255, 118, 20, 0.07)'
                  }}
                >
                  <Link
                    to={settings.link_register}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center justify-center px-[8px] py-[10px] rounded-full w-full h-full font-bold text-[16px] leading-[24px] text-center whitespace-nowrap text-white relative overflow-hidden"
                    style={{
                      background: 'linear-gradient(to bottom, rgba(255, 214, 179, 0), #df630b)',
                      boxShadow: 'inset 0px 4px 4px 0px rgba(255, 191, 0, 0.16)'
                    }}
                  >
                    ĐĂNG KÝ
                  </Link>
                </div>
              </>
            )}
          </div>
          <div className="relative xl:hidden flex flex-col gap-1.5 items-center justify-center mt-1 shrink-0 w-[min(136px,50vw)]">
            {isLoggedIn ? (
              <div className="relative w-full" ref={userMenuRefMobileBar}>
                <button
                  type="button"
                  onClick={() => setUserMenuOpen((v) => !v)}
                  className="flex w-full items-center justify-center gap-1 rounded-full border border-[#e5e7eb] bg-white/95 py-1.5 pl-2 pr-1.5 shadow-sm"
                  aria-expanded={userMenuOpen}
                >
                  <div className="flex min-w-0 flex-1 flex-col items-start pl-0.5">
                    <span className="text-[9px] leading-tight text-[#6b7280]">Xin chào</span>
                    <span className="w-full truncate text-[11px] font-bold leading-tight text-[#111827] text-start">
                      {authAccount || '·'}
                    </span>
                  </div>
                  <div className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-primary">
                    <UserOutlined className="text-[13px] text-white" />
                  </div>
                  <DownOutlined
                    className={`shrink-0 text-[9px] text-[#6b7280] ${userMenuOpen ? 'rotate-180' : ''}`}
                  />
                </button>
                {userMenuOpen ? (
                  <div className="absolute right-0 top-[calc(100%+4px)] z-[100] min-w-[140px] overflow-hidden rounded-[10px] bg-white shadow-none ring-0">
                    <button
                      type="button"
                      className="w-full border-0 bg-white px-3 py-2.5 text-left text-[13px] font-bold text-[#111827] shadow-none outline-none ring-0 hover:bg-[#f3f4f6]"
                      onClick={() => {
                        setUserMenuOpen(false);
                        handleLogout();
                      }}
                    >
                      Đăng xuất
                    </button>
                  </div>
                ) : null}
              </div>
            ) : (
              <button
                type="button"
                onClick={openLoginModal}
                className="w-full h-[32px] rounded-full text-[12px] sm:text-[13px] font-bold text-[#f27121] border-2 border-[#e8ebee] bg-[#f8f9fb] hover:border-[#f27121]/40 transition-colors"
              >
                Đăng nhập
              </button>
            )}
          </div>
        </div>
      </div>
      <div className="w-full h-auto flex justify-center items-center relative">
        <img
          src="/assets/images/header/banner_pc.png"
          alt=""
          className="w-full max-w-[1000px] h-auto object-contain py-2 flex"
        />
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 mt-[10px] md:mt-[24px]">
          <CountDownFinal />
        </div>
      </div>

      {/* <div className="flex justify-center items-center w-full px-2 mb-3">
        <div className="md:hidden flex flex-row justify-center items-center w-full gap-2 sm:gap-3 lg:gap-10 py-3 rounded-full bg-white">
          {navItems.map((item) =>
            item.name === 'Trang chủ' ? null : (
              <Link
                key={item.name}
                to={item.href}
                className={`text-center text-[14px] px-5 py-2 rounded-lg sm:text-[16px] font-semibold ${
                  activeNav === item.href
                    ? 'text-[#FFF] bg-[#f27121]'
                    : 'text-[#f27121] bg-transparent'
                }`}
              >
                {item.name}
              </Link>
            )
          )}
          <button
            onClick={() => setIsModalHistory(true)}
            className={`text-center text-[14px] sm:text-[16px] font-semibold text-[#f27121] cursor-pointer bg-transparent border-0`}
          >
            LỊCH SỬ
          </button>
        </div>
      </div> */}

      <LoginModal
        open={isLoginModalOpen}
        onClose={() => setIsLoginModalOpen(false)}
        registerHref={settings.link_register}
        onLoggedIn={syncAuthState}
      />
    </div>
  );
};

export default Header;
